import { render, staticRenderFns } from "./CoursePageHeader.vue?vue&type=template&id=285d5dba&"
import script from "./CoursePageHeader.vue?vue&type=script&lang=js&"
export * from "./CoursePageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIBreadcrumb: require('/opt/build/repo/components/UI/Breadcrumb.vue').default,UIReviewsAlt: require('/opt/build/repo/components/UI/ReviewsAlt.vue').default})
